import { IconType } from "react-icons/lib";

interface ClarificationRowActionButtonProps {
	colorOverride?: string;
	hoverColorOverride?: string;
	icon: IconType;
	title: string;
	onClick: () => void
}


export const ClarificationRowActionButton: React.FC<ClarificationRowActionButtonProps> = ({
	colorOverride,
	hoverColorOverride,
	icon: Icon,
	title,
	onClick
}) => {

	const color = colorOverride ?? "text-blue-600";
	const hoverColor = hoverColorOverride ?? "hover:text-blue-800";

	return <button
		onClick={onClick}
		className={`inline-flex items-center ${color} ${hoverColor}`}
		title={title}
	>
		<Icon className="h-4 w-4" />
	</button>
}